// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import ReactMarkdown from "react-markdown";
import * as NextImage$PorterinFeature from "../../../ui/components/NextImage.mjs";
import * as FaqAccordionItemModuleScss from "../styles/FaqAccordionItem.module.scss";

var styles = FaqAccordionItemModuleScss;

function FaqAccordionItem(Props) {
  var containerClassOpt = Props.containerClass;
  var headerClassOpt = Props.headerClass;
  var bodyClassOpt = Props.bodyClass;
  var onClick = Props.onClick;
  var isActive = Props.isActive;
  var header = Props.header;
  var content = Props.content;
  var toggle_icon = Props.toggle_icon;
  var containerClass = containerClassOpt !== undefined ? containerClassOpt : "";
  var headerClass = headerClassOpt !== undefined ? headerClassOpt : "";
  var bodyClass = bodyClassOpt !== undefined ? bodyClassOpt : "";
  return React.createElement("div", {
              className: "" + styles.item + " " + containerClass + ""
            }, React.createElement("div", {
                  className: "" + styles["header-container"] + " " + (
                    isActive ? styles.active : ""
                  ) + "",
                  onClick: onClick
                }, React.createElement("h3", {
                      className: "" + styles.header + " " + headerClass + ""
                    }, header), React.createElement("div", {
                      className: styles["arrow-icon"]
                    }, React.createElement(NextImage$PorterinFeature.make, {
                          src: toggle_icon.path,
                          height: 24.0,
                          width: 24.0,
                          quality: 75.0,
                          alt: toggle_icon.alt_text
                        }))), React.createElement("div", {
                  className: "" + styles.body + " " + (
                    isActive ? styles.active : styles.inactive
                  ) + ""
                }, React.createElement("div", {
                      className: bodyClass
                    }, React.createElement(ReactMarkdown, {
                          children: content
                        }))));
}

var make = FaqAccordionItem;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
